module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"other":"Your camera is unavailable. Please try another device.","notConnected":"It looks like your camera is not connected. Please connect your camera."}}')
  delete Component.options._Ctor
}
